module.exports = __webpack_public_path__ + "static/img/884.eb4f0db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/884.jpg
// module id = quxn
// module chunks = 0